import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import { useStores } from "_common/hooks";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "_common/component/NotifyProvider";
import { formatNumber } from "_common/utils/formatValue";
import i18next from "i18next";
import { get } from "lodash";
import { gameTypeList } from "_common/constants/statusType";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Slider from "rc-slider";

import ModalBet from "./ModalBet";

const buttons = [100, 200, 500, 1000, 2000, 5000, 10000];

export default function GameBoard({ game_id, mainCoin, direction }) {
  const queryClient = useQueryClient();
  const { isMobile } = useMediaQuery();
  const { pushNotify, dataGame } = useNotify();
  const {
    authStore: { user, display_balance, loading, setLoading, general },
  } = useStores();
  const typeBet = [
    {
      type: "usdt",
      text: i18next.t("USDT"),
    },
  ];
  const [game_type, setGameType] = useState(direction || "buy");
  const [bet_type, setBetType] = useState(gameTypeList[0].time);
  const [amount, setAmount] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  const gameProfit = useMemo(
    () => gameTypeList?.find((item) => item?.time === bet_type),
    [bet_type]
  );

  const handleChangeInput = (event) => {
    if (!event?.target?.value) {
      setAmount();
    } else {
      setAmount(Number(event?.target?.value));
    }
  };

  return (
    <div className="feature-board">
      <div className="list-cycle mt-[15px]">
        {gameTypeList?.map((item) => (
          <button
            type="button"
            key={item?.time}
            className={classNames("item", {
              active: bet_type === item?.time,
            })}
            onClick={() => setBetType(item.time)}
          >
            <p>{i18next.t("profit")}</p>
            <h5>{item?.profit}%</h5>
            <div className="text-[14px] w-full text-center bg-[#3D5AFE] rounded-b-lg text-[#fff] whitespace-nowrap">
              {item?.text} {i18next.t("minute")}
            </div>
          </button>
        ))}
      </div>
      <p className="flex items-center justify-between mt-4">
        <span className="text-[12px] text-[#888888]">
          {i18next.t("balance_available")}
        </span>
        <span className="text-[12px] text-[#fff]">
          {formatNumber(user?.balance, "0,0.[00000]")}&nbsp;USDT
        </span>
      </p>
      <div className="h-[44px] flex items-center px-3 mt-2 ">
        <Slider
          marks={{ 20: 20, 40: 40, 60: 60, 80: 80, 100: 100 }}
          min={0}
          max={100}
          step={null}
          tipFormatter={(value) => `${value}%`}
          onChange={(nextValue) => {
            setAmount((Number(get(user, "balance", 0)) * nextValue) / 100);
            // setValue(nextValue as any);
          }}
        />
      </div>
      <div className="qty-input mt-[10px]">
        <input
          placeholder="0.00"
          type="number"
          inputMode="decimal"
          className="sbui-input sbui-input--large"
          min={0}
          step="0.000001"
          value={amount}
          onChange={handleChangeInput}
        />
        <span className="text-gray-400 font-thin text-lg">USDT</span>
      </div>
      <p className="text-[#fff] text-md mt-2">
        ≈{formatNumber(amount, "0,0.[000000]")} USD
      </p>
      <div className="mt-4">
        <button
          type="button"
          className={classNames("btn !bg-[#55af72]")}
          onClick={() => {
            setGameType("buy");
            setOpenModal(true);
          }}
        >
          {i18next.t("buy")}
        </button>
        <button
          type="button"
          className={classNames("btn !bg-[#dd5350] mt-2")}
          onClick={() => {
            setGameType("sell");
            setOpenModal(true);
          }}
        >
          {i18next.t("sell")}
        </button>
      </div>
      {openModal && (
        <ModalBet
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
          data={{
            game_id,
            type: bet_type,
            profit_rate: gameProfit?.profit,
            game_type,
            amount,
          }}
        />
      )}
    </div>
  );
}
